var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpg(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Images"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.27726 2.40723H27.6111C29.2954 2.40723 30.6668 3.79381 30.6668 5.49666V19.0893C30.6668 20.7922 29.2954 22.1787 27.6111 22.1787H9.27726C7.59319 22.1787 6.22171 20.7922 6.22171 19.0893V5.49666C6.22171 3.79381 7.59319 2.40723 9.27726 2.40723ZM27.6111 4.87873H9.27726C8.94004 4.87873 8.66629 5.15543 8.66629 5.4966V17.1605L12.0397 13.751C12.8745 12.9059 14.2349 12.9059 15.0708 13.751L16.5497 15.2426L21.0893 9.73391C21.495 9.24202 22.089 8.95784 22.7221 8.95425C23.3589 8.96891 23.9517 9.22847 24.3613 9.71404L28.2223 14.2689V5.49666C28.2223 5.15549 27.9486 4.87873 27.6111 4.87873ZM4.64264 20.8798C5.2747 22.7655 7.01515 24.0321 8.97182 24.0321H26.7153L25.6142 27.5723C25.3024 28.776 24.1901 29.5928 22.9728 29.5928C22.7353 29.5926 22.4987 29.5619 22.2688 29.5014L3.36896 24.3842C1.9109 23.9776 1.04188 22.4517 1.42322 20.9798L4.38837 10.973V19.3982C4.38837 19.8184 4.45082 20.2383 4.5999 20.7377L4.64264 20.8798ZM14.7774 8.58566C14.7774 9.94866 13.6813 11.0572 12.3331 11.0572C10.9849 11.0572 9.88851 9.94861 9.88851 8.58566C9.88851 7.2227 10.9849 6.11416 12.3331 6.11416C13.6813 6.11416 14.7774 7.22265 14.7774 8.58566Z",
    fill: "#A3A3A3"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpg);
export default __webpack_public_path__ + "static/media/opg.b8c225a3bc61dc4d4cdbce58ebfb74ac.svg";
export { ForwardRef as ReactComponent };